import styled from "styled-components";
import theme from "../../../../../styles/theme";

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  color: black;
  width: 100%;
  height: 100%;
  row-gap: 1vh;
  margin-top: 1vh;
  text-align: center;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

export const StyledMessage = styled.p`
  font-size: 20px;
  color: ${theme.colors.brown.primary};
  font-weight: 600;
  margin: 0 0 20px 0;
  padding: 20px;
  border: 1px solid ${theme.colors.brown.primary};
  border-radius: 8px;
  background-color: ${theme.colors.palete.brownExtraLighter || "#FFF"};
  text-align: center;
`;
